import {makeStyles} from "@material-ui/core";
import {Colors} from "../../styles/Colors";

export const useStyles = makeStyles(() => ({
        mainDashboardContainer: {
            width: '100%',
            height: '100vh',
            display: 'flex',
            flexDirection: "column",
            background: Colors.White,
            overflow: 'hidden',
            position: 'relative',
        },
        filtersContainer:{
          marginTop:0
        },
        itemsContainer: {
            marginTop:0
        },
        loader: {
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: 'calc(100% - 54px - 54px)',
            padding: '24px 96px',
        },
        listViewHeader: {
            height: 62,
        },
        rightSection: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        },
        containerBg: {
            padding: '48px 96px',

            background: Colors.SmokeBackground,
            borderRadius: 4,
        },
        table: {
            marginBottom: 80,
        },
        audioBox: {},
        '@media (min-width:1277px) and (max-width: 1440px)': {
            audioBox: {
                maxWidth: 1007,
                left: '98px !important',
            },
        },
        '@media (min-width: 1441px)': {
            audioBox: {
                left: '98px !important',
            },
        },
    }
));
